export class EnvUtils {
  static getBoolean(key: string, defaultValue: boolean = false): boolean {
    const val = process.env[key];
    if (val === 'true') return true;
    if (val === 'false') return false;
    return defaultValue;
  }

  static getString(key: string, defaultValue: string = ''): string {
    const value = process.env[key];
    return (value !== undefined && value !== null) ? value : defaultValue;
  }

  static getNumber(key: string, defaultValue: number = 0): number {
    const val = Number(process.env[key]);
    return isNaN(val) ? defaultValue : val;
  }
}
